<button class="q-btn" [ngClass]="class" (click)="SaveGrid()" [title]="mode == 'SAVE' ? 'Enregistrer la configuration des colonnes' : 'Réinitialiser la configuration des colonnes'">
  <i *ngIf="isLoading ; else SaveFont" class="fas fa-spinner fa-spin fa-pulse"></i>
  <ng-template #SaveFont>
    <i *ngIf="mode == 'SAVE' ; else DeleteFont" class="fas fa-save  q-c-secondary"></i>
    <ng-template #DeleteFont><i class="fas fa-redo-alt fa-flip-horizontal q-c-secondary"></i></ng-template>
    </ng-template>
</button>
